"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MIN_SAFETY_NUMBER = exports.MAX_SAFETY_NUMBER = void 0;
exports.MAX_SAFETY_NUMBER = Math.pow(2, 53) - 1;
exports.MIN_SAFETY_NUMBER = -1 * Math.pow(2, 53) + 1;
